import { apiRequest, Permission } from "@vojomo-core/shared";
import { useEffect, useRef, useState } from "react";

export const usePermissions = (refId: string, refType: string) => {
  const [hasReadAccess, setHasReadAccess] = useState<boolean>(null);
  const [hasWriteAccess, setHasWriteAccess] = useState<boolean>(null);

  const [permissions, setPermissions] = useState<Permission>(null);
  const refreshIntervalRef = useRef(null);

  const fetchPermissions = async () => {
    const data = await apiRequest<Permission>({
      subRoute: "topic",
      path: `/permissions?ref_id=${refId}&ref_type=${refType}`
    });

    setPermissions(data);
  };

  const checkPermissions = async () => {
    const data = await apiRequest<{ read: boolean; write: boolean }>({
      subRoute: "topic",
      path: `/check_permissions?ref_id=${refId}&ref_type=${refType}`
    });

    setHasReadAccess(data.read);
    setHasWriteAccess(data.write);
  };

  useEffect(() => {
    if (refId) {
      fetchPermissions();
      checkPermissions();

      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
        refreshIntervalRef.current = null;
      }

      refreshIntervalRef.current = setInterval(checkPermissions, 10000);
    }
  }, [refId]);

  useEffect(() => {
    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
        refreshIntervalRef.current = null;
      }
    };
  }, []);

  return {
    permissions,
    hasReadAccess,
    hasWriteAccess,
    fetchPermissions,
    checkPermissions
  };
};
